var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinbaseLogo2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2682_32517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7139 0C18.3398 0 23.7139 5.37408 23.7139 12C23.7139 18.6259 18.3398 24 11.7139 24C5.08795 24 -0.286133 18.6259 -0.286133 12C-0.286133 5.37408 5.08795 0 11.7139 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7177 16.2191C9.38683 16.2191 7.49947 14.3308 7.49947 11.9999C7.49947 9.66906 9.38779 7.7817 11.7177 7.7817C13.8057 7.7817 15.5395 9.30426 15.8736 11.2972H20.1235C19.7644 6.9657 16.1404 3.5625 11.7177 3.5625C7.05979 3.5625 3.28027 7.34202 3.28027 11.9999C3.28027 16.6579 7.05979 20.4374 11.7177 20.4374C16.1404 20.4374 19.7654 17.0342 20.1235 12.7027H15.8697C15.5356 14.6966 13.8057 16.2191 11.7177 16.2191Z",
    fill: "#0052FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2682_32517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.8857,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbaseLogo2);
export default __webpack_public_path__ + "static/media/coinbaseLogo2.9994ff5cf05f1a804d82ff67e2f6832d.svg";
export { ForwardRef as ReactComponent };